import { Injectable } from '@angular/core';
import { BaseHttpService } from './basehttp.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Constants } from '../constants';
import { forkJoin, Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { SyncSurveyAttestation } from '../models/survey-intake-sync-record.model';
import { fork } from 'child_process';

@Injectable({ providedIn: 'root' })
export class SyncSurveyService {
  private constants: Constants = new Constants();

  constructor(private http: BaseHttpService, private spinner: NgxSpinnerService) {}

   DataURIToBlob(dataURI: string) {
        const splitDataURI = dataURI.split(',')
        const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
        const mimeString = splitDataURI[0].split(':')[1].split(';')[0]

        const ia = new Uint8Array(byteString.length)
        for (let i = 0; i < byteString.length; i++)
            ia[i] = byteString.charCodeAt(i)

        return new Blob([ia], { type: mimeString })
      }

  /**
   * Upload attestation PDFs to S3.
   * @param attestationPdfFiles Array of objects containing pdfData + incidentId
   * @param surveyId Survey identifier used as folder name
   */
  uploadAttestationPdfToS3(attestationPdfFiles: any[], surveyId: string): Observable<{responseId: string, filePath: string}[]> {
    //debugger;
    const fileUploadRequests = attestationPdfFiles.map((file) => {
      const id = file.incidentId;
      const pdfDataArray = JSON.parse(file.pdfData);
      const pdfItem = pdfDataArray[0]; // Get first item from parsed array

      const fileBlob = this.DataURIToBlob(pdfItem.value);
      const formData = new FormData();
      formData.append('Id', id.toString());
      formData.append('AgencyId', file.agencyId.toString());
      formData.append('AgencyName', file.agencyName.toString());
      formData.append('file', fileBlob, pdfItem.Name);
      formData.append('name', pdfItem.Name);
      formData.append('FilePath', surveyId + '/' + id.toString());
      formData.append('IsScanEnabled', "false");
      
      return this.http.post(
        this.constants.uploadFileUrl,
        formData
      );;
    });
    console.log('fileUploadRequests', fileUploadRequests);
    
    return forkJoin(fileUploadRequests).pipe(
      catchError(err => {
        if (err.status === 500) {
          console.log('[SyncSurveyService] UploadFileToS3 returned 500');
        }
        return of([]);
      })
    );
    // return this.http.post(this.constants.uploadFileUrl, fileUploadRequests).pipe(
    //   map((result: {responseId: string, filePath: string}[]) => {
    //     return result;
    //   }),
    //   catchError(err => {
    //     if (err.status === 500) {
    //       console.log('[SyncSurveyService] UploadFileToS3 returned 500');
    //     }
    //     return of([]);
    //   })
    // );
  }

  /**
   * Upload an Excel file (Blob) to S3.
   * @param excelBlob The Excel file as a Blob
   * @param fileName The file name for the Excel
   * @param surveyId Survey identifier used as folder name
   * @param surveyResponseId Survey response identifier
   */
  uploadExcelToS3(excelBlob: Blob, fileName: string, surveyId: string, surveyResponseId: number): Observable<{ filePath: string, name: string }> {
    const formData = new FormData();
    formData.append('Id', surveyResponseId.toString());
    formData.append('file', excelBlob, fileName);
    formData.append('name', fileName);
    formData.append('FilePath', surveyId + '/' + surveyResponseId.toString());

    return this.http.post(this.constants.uploadFileUrl, formData).pipe(
      map((result: any) => {
        return { filePath: result.filePath, name: result.name };
      }),
      catchError(err => {
        console.warn('[SyncSurveyService] uploadExcelToS3 failed:', err);
        return of(null);
      })
    );
  }

  /**
   * Sync attestation metadata to IDD.
   * API now expects wrapper key: { syncSurveyAttestations: SurveyIntakeSyncRecord[] }
   */
  syncAttestationDataToIdd(surveyId: string, attestationFiles: any[], uploadResponse: any[]): Observable<boolean> {
    const syncSurveyAttestations = uploadResponse.map(resp => {
      const attestationFile = attestationFiles.find(f => f.incidentId == resp.id) || {};
      return {
        surveyId: surveyId,
        surveyResponseId: resp.id,
        surveyAttestationPdf: `{"filePath": "${resp.filePath}", "name": "${resp.name}"}`,
        AgencyId: resp.agencyId || null,
        AgencyName: resp.agencyName || ''
      };
    });
    const payload = { "syncSurveyAttestations": syncSurveyAttestations };
    return this.http.post(this.constants.SyncSurveyAttestationDataToIdd, payload, {"Content-Type": "application/json"}).pipe(
      map(() => true),
      catchError(err => of(false))
    );
  }
}
